<template>
    <section class="users-list">
        <!-- <p class="users-finded">Надено 1203 человека</p> -->
        <div class="users-body">
            <ElementOffer v-for="offer in users" :key="offer.id" :user="offer" :v-if="users && !users.error && !loader"/>
        </div>
        <!-- <div class="nothing" v-if="!users || users.error && !loader">
            <p>Что-то пошло не так...</p>
        </div> -->
        <div class="nothing" v-if="users && users.length === 0">
            <p v-if="$route.name === 'offers'">Пока что, вам не предлагают дружбу, <router-link :to="{name: 'users'}">добавьте новых</router-link> или <span>пригласите старых</span> друзей.</p>
            <p v-else-if="$route.name === 'myoffers'">Пока что, вы никому не предложили дружбу, <router-link :to="{name: 'users'}">добавьте новых</router-link> или <span>пригласите старых</span> друзей.</p>
            <p v-else>Ничего не найдено</p>
        </div>
            
    </section>
</template>
<script>
export default {
    name: 'OffersList',
    props: {
        users: {
            type: Array,
            required: false
        },
        category: {
            type: String,
            required: false
        },
        loader: {
            type: Boolean,
            required: false
        }
    },
    components: {
        ElementOffer: () => import('@/components/Users/ElementOffer')
    }
}
</script>